<template>
    <div>

        <!-- Alternate signups -->
        <div class="ph3 mt3">
            <FacebookButton class="mv2">Sign up with Facebook</FacebookButton>
            <GoogleButton>Sign up with Google</GoogleButton>
        </div>

        <!-- or -->
        <LabeledLine class="mv3"><h6 class="mid-gray">or</h6></LabeledLine>

        <div class="ph3">

            <!-- Form inputs -->
            <LabeledControl class="mb2" label="Full Name" notice="Required">
                <Textbox v-model="registration.name" />
            </LabeledControl>

            <LabeledControl class="mb2" label="Email" notice="Required">
                <Textbox v-model="registration.email" type="email"/>
            </LabeledControl>

            <LabeledControl label="Password" notice="Required">
                <Textbox v-model="registration.password" type="password"/>
            </LabeledControl>

            <!-- Terms & Conditions -->
            <div class="custom-font mv3">
                By signing up, you agree to our
                <router-link to="error-page" class="link black pointer">
                    <span style="font-weight: 900;" class="dib mt1 grow">Terms of Use</span>
                </router-link>
                and
                <router-link to="error-page" class="link black pointer">
                    <span style="font-weight: 900;" class="dib grow">Privacy Policy</span>
                </router-link>
            </div>

            <!-- Regular signup button -->
            <TooliabaButton @click="register(registration)">Sign Up for Free</TooliabaButton>

        </div>

    </div>
</template>

<script>
import FacebookButton from '@/components/buttons/FacebookButton.vue';
import GoogleButton from '@/components/buttons/GoogleButton.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import LabeledControl from '@/components/controls/LabeledControl.vue';
import Textbox from '@/components/controls/Textbox.vue';
import LabeledLine from '@/components/controls/LabeledLine.vue';

export default {
    components: {
        FacebookButton,
        GoogleButton,
        TooliabaButton,
        LabeledControl,
        Textbox,
        LabeledLine
    },
    data: function() {
        return {
            registration: {
                name: '',
                email: '',
                password: ''
            }
        };
    },
    methods: {
        register() {
            this.$auth.register({
                data: this.registration
            });
        }
    }
};
</script>
